import React from "react";

class DesktopFooter extends React.Component {

    render() {
        return (
            <><div className="container">
                <span
                    style={{
                        marginTop: "20px",
                        width: "100%",
                        borderBottom: "dotted 1px #333",
                        display: "block",
                        opacity: "0.3",
                        height: "1px",
                    }}
                ></span>
                {/* <span
                    style={{
                        width: "100%",
                        borderBottom: "dotted 1px #333",
                        display: "block",
                        opacity: "0.3",
                        height: "1px",
                    }}
                ></span>
                <span
                    style={{
                        width: "100%",
                        borderBottom: "dotted 1px #333",
                        display: "block",
                        opacity: "0.3",
                        height: "1px",
                    }}
                ></span> */}
                <div
                    className={"fullWidth"}
                    style={{
                        height: "fit-content",
                        overflow: "hidden",
                        paddingLeft: "0",
                        paddingRight: "0",
                        fontSize: "12px",
                        alignContent: "center",
                        textAlign: "center",
                        alignItems: "center",
                        // background: "var(--color-fill-tertiary)",
                        // backgroundColor: "#7c8b72",

                    }}
                >
                    <div className={"run-wrapper"}>
                        <marquee behavior="alternate"><span className={"marquee"}>This website was found with the purpose of sharing practice knowledge related to the machine learning field, from a clearly explained perspective to a practical real-world application.
                            I hope my works and my research can deliver usefulness for the developer or machine learning participants, specially for who is interested and need overviews and good point to start to become deeply understanding machine learning/ AI algorithms.
                            Any feedback or comment is a label for my future direction. Please enjoy this site. I am happy to receive your contribution and support to help me build more quality contents in the future.
                        </span></marquee>
                    </div>

                    {/* <div id="scroll-container">
                        <div id="scroll-text">This website was found with the purpose of sharing practice knowledge related to the machine learning field, from a clearly explained perspective to a practical real-world application.
                            I hope my works and my research can deliver usefulness for the developer or machine learning participants, specially for who is interested and need overviews and good point to start to become deeply understanding machine learning/ AI algorithms.
                            Any feedback or comment is a label for my future direction. Please enjoy this site. I am happy to receive your contribution and support to help me build more quality contents in the future.<div>
                            </div> */}

                    {/* <blockquote>
                        <p>This website was found with the purpose of sharing practice knowledge related to the machine learning field, from a clearly explained perspective to a practical real-world application.
                            I hope my works and my research can deliver usefulness for the developer or machine learning participants, specially for who is interested and need overviews and good point to start to become deeply understanding machine learning/ AI algorithms.
                            Any feedback or comment is a label for my future direction. Please enjoy this site. I am happy to receive your contribution and support to help me build more quality contents in the future.</p>
                        <p></p>
                    </blockquote> */}

                    {/* <div id="scroll-container">
                                <div id="scroll-text">
                                This website was found with the purpose of sharing practice knowledge related to the machine learning field, from a clearly explained perspective to a practical real-world application.
                            I hope my works and my research can deliver usefulness for the developer or machine learning participants, specially for who is interested and need overviews and good point to start to become deeply understanding machine learning/ AI algorithms.
                            Any feedback or comment is a label for my future direction. Please enjoy this site. I am happy to receive your contribution and support to help me build more quality contents in the future.
                                </div>
                            </div> */}

                    <div
                        // className="container"
                        style={{
                            color: "white",
                            bottom: "0",
                            height: "fit-content",
                            width: "100%",
                            alignItems: "center",
                            alignContent: "stretch",
                            textAlign: "left",
                            fontWeight: "bold",
                            fontSize: "14px",
                            margin: "0",
                            padding: "0 !important"
                        }}
                    >
                        <a style={{ marginLeft: 0 }} className="footer-section" href="/privacy">Privacy </a>
                        <a className="footer-section" href="/disclaimer">Disclaimer </a>
                        <a className="footer-section" href="/terms">Terms </a>
                        <a className="footer-section" href="/service">Contact </a>
                    </div>
                    <div
                        // className="container"
                        style={{
                            color: "gray",
                            bottom: "0",
                            height: "fit-content",
                            backgroundColor: "transparent",
                            width: "100%",
                            alignItems: "center",
                            alignContent: "stretch",
                            textAlign: "right",
                            fontWeight: "bold",
                            fontSize: "14px",
                            marginTop: "10px",
                            marginBottom: "10px"
                        }}
                    >
                        <a className="footer-section" href="https://www.youtube.com/@lochotan2428">Youtube </a>
                        <a className="footer-section" href="https://twitter.com/LcHTn8">Twitter </a>
                        <a className="footer-section" href="https://www.facebook.com/profile.php?id=100066852246652">Facebook </a>
                        <a className="footer-section" href="/terms">Newsletter </a>
                        <a style={{ marginRight: 0 }} className="footer-section" href="/terms">RSS</a>
                    </div>
                    <div style={{ color: "gray", fontWeight: "bold", marginTop: "0.5 rem", marginBottom: "0.5 rem" }}>Copyright © 2023 Machine Learning Practices</div>
                </div></div>
            </>
        )
    }
}

export default DesktopFooter;
